import React, { useState } from 'react';
import { Button, Card, Col, Form, Input, Modal, notification, Row } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import { authAxios } from '../../services/auth-axios';

export function AdminSetPasswordModal({ user, onPasswordChanged }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const open = () => setModalOpen(true);

  const close = () => setModalOpen(false);

  const handleSetPassword = async ({ password }) => {
    setLoading(true);

    try {
      await authAxios().patch(`/users/${user.id}/password`, { password });

      notification.success({ message: 'Senha do usuário alterada com sucesso!' });

      setTimeout(() => {
        close();
      }, 500);
    } catch (error) {
      console.error('Error setting user password:', error);
      notification.error({ message: 'Erro ao alterar a senha do usuário' });
    } finally {
      onPasswordChanged?.();
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={open} size="large" style={{ backgroundColor: 'purple' }} icon={<KeyOutlined />} aria-label="Alterar senha do usuário" />

      <Modal open={modalOpen} onCancel={close} footer={null} afterClose={form.resetFields}>
        <Card title={`Alterar senha de ${user.name}`}>
          <Form layout="vertical" onFinish={handleSetPassword} form={form} id="adminSetPasswordForm">
            <Form.Item name="password" label="Nova senha" required rules={[{ required: true, message: 'Campo obrigatório!' }]}>
              <Input.Password placeholder="Digite a nova senha" />
            </Form.Item>

            <Form.Item>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Button disabled={loading} form="adminSetPasswordForm" htmlType="submit" type="primary" block>
                    Alterar senha
                  </Button>
                </Col>
                <Col span={24}>
                  <Button disabled={loading} block type="dashed" onClick={close}>
                    Fechar
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </>
  );
}
